import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RecentBadges() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = () =>
      axios
        .get(`${API}/badges/recent?limit=20`)
        .then((r) => {
          if (!cancelled) setEvents(r.data?.events || []);
        })
        .catch(() => {});
    load();
    const t = setInterval(load, 60000); // refresh every 60s
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, []);

  if (!events.length) return null;

  // Duplicate for seamless marquee loop
  const loop = [...events, ...events];

  return (
    <section
      data-testid="recent-badges"
      className="relative bg-[#0F0F0F] border-y-2 border-[#D4AF37] overflow-hidden"
      aria-label="Recently earned badges"
    >
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#0F0F0F] to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#0F0F0F] to-transparent z-10 pointer-events-none" />

      <div className="flex items-center py-3 gap-3">
        <span className="flex-shrink-0 bg-[#D4AF37] text-black text-[10px] font-bold uppercase tracking-widest px-3 py-1.5 ml-4">
          🏆 Recently Earned
        </span>
        <div className="flex-1 overflow-hidden">
          <div className="flex gap-8 animate-marquee whitespace-nowrap">
            {loop.map((e, i) => (
              <div
                key={i}
                data-testid={`recent-badge-item-${i % events.length}`}
                className="flex items-center gap-2 text-sm"
              >
                <span className="text-xl">{e.badge_icon || "🏆"}</span>
                <span className="text-neutral-400">
                  <span className="text-white font-bold">{e.user_name}</span>{" "}
                  unlocked{" "}
                  <span className="text-[#D4AF37] font-bold">
                    {e.badge_title}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
